export default __webpack_public_path__ + "static/media/Rattlecurse.8797a415.jpg";